
<div class="spacing">
  <div class="bolder margin-bottom-sm">Residents
    <button class="btn btn--right btn--solid btn--red" (click)="updateSeats()" *ngIf="oiteProduct?.seatAssignmentPeriodActive" [disabled]="this.filterOnlyChangedSeats(this.updatedResidents).length === 0">Save</button>
  </div>
  <div class="margin-bottom-sm">Registered Residents for OITE = {{ registeredCount }}<br />Not registered for OITE = {{ notRegisteredCount }}</div>
  <table class="spacing mat-elevation-z8" matSort mat-table  matSortActive="residencyPostGraduateYear" matSortDirection="asc" [dataSource]="dataSource">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox color="primary" (change)="masterToggle()" [checked]="isAllSelected()" [disabled]="!editPrivileges || !oiteProduct?.seatAssignmentPeriodActive">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let resident">
        <mat-checkbox [checked]="resident.seatAssigned"  [disabled]="!editPrivileges || !oiteProduct?.seatAssignmentPeriodActive" (change)="toggleSeatAssigned(resident)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="residencyPostGraduateYear">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="left-padding"> Year </th>
      <td mat-cell class="roster-table-top-padding" *matCellDef="let resident" class="left-padding">
        <span [ngClass]="{'roster-table-number-one': resident.residencyPostGraduateYear ==='1', 
          'roster-table-number-two': resident.residencyPostGraduateYear ==='2', 
          'roster-table-number-three': resident.residencyPostGraduateYear ==='3',
          'roster-table-number-four': resident.residencyPostGraduateYear ==='4',
          'roster-table-number-five': resident.residencyPostGraduateYear ==='5'}"></span>
      </td>
    </ng-container>
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> First Name </th>
      <td mat-cell *matCellDef="let resident"> {{resident.firstName}} </td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </th>
      <td mat-cell *matCellDef="let resident"> {{resident.lastName}} </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer ID </th>
      <td mat-cell *matCellDef="let resident"> {{ trimLeadingZeros(resident.id) }} </td>
    </ng-container>
    <ng-container matColumnDef="institutionalEmail">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let resident"> {{resident.institutionalEmailAddress}} </td>
    </ng-container>
    <ng-container matColumnDef="residencyDates">
      <th mat-header-cell *matHeaderCellDef> Dates of Residency </th>
      <td mat-cell *matCellDef="let resident"> {{resident.residencyBeginDate | date: 'MMMM d, yyyy'}} to
        {{resident.residencyEndDate | date: 'MMMM d, yyyy'}}</td>
    </ng-container>
    <ng-container matColumnDef="npi">
      <th mat-header-cell *matHeaderCellDef> NPI </th>
      <td mat-cell *matCellDef="let resident"> {{resident.npi}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>

  </table>
</div>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
